import React from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import Card from '~/ui/components/Card/index';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';

import ItemPartySigner from './ItemPartySigner';

function PartySignerCard({
  parties,
  title,
  type,
  onAddParty,
  onAddSigner,
  onRemoveParty,
  onRemoveSigner,
}) {
  const intl = useIntl();

  return (
    <Box sx={{ width: '400px' }}>
      <Card
        isFullHeight
        header={
          <Card.Header
            title={title}
            rightContent={
              <Button
                text={intl.formatMessage({
                  id: 'PartySignerCard.addPartyText',
                  defaultMessage: 'Add Party',
                  description: 'Button text for adding a new party',
                })}
                variant="action"
                onClick={() => onAddParty({ type })}
              />
            }
          />
        }
      >
        {parties.map((party, partyIndex) => (
          <React.Fragment key={party.id}>
            {partyIndex > 0 && <Box my={4} sx={{ borderBottom: 'border' }} />}
            <FlexLayout flexDirection="column" space={1}>
              <ItemPartySigner
                name={party.name}
                onRemove={() => onRemoveParty({ partyId: party.id, type })}
              />
              <FlexLayout flexDirection="column" ml={6} space={5}>
                <FlexLayout flexDirection="column" space={1}>
                  {party.signers.map((signer) => (
                    <ItemPartySigner
                      key={signer.id}
                      name={signer.name}
                      onRemove={() =>
                        onRemoveSigner({ signerId: signer.id, type })
                      }
                    />
                  ))}
                </FlexLayout>
                <Button
                  text={intl.formatMessage({
                    id: 'PartySignerCard.addSignersText',
                    defaultMessage: 'Add Signers',
                    description: 'Button text for adding signers to a party',
                  })}
                  variant="action"
                  onClick={() => onAddSigner({ partyId: party.id, type })}
                />
              </FlexLayout>
            </FlexLayout>
          </React.Fragment>
        ))}
      </Card>
    </Box>
  );
}

export default PartySignerCard;
